export default __webpack_public_path__ + "static/media/aircare-poster-1.cb9d6b7a.jpg";